var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "900" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline m-0" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [_c("v-icon", [_vm._v("add")]), _vm._v(" Asignación Horario ")],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "p-0" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "py-0 px-4",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c(
                                "v-radio-group",
                                {
                                  model: {
                                    value: _vm.tipo_asignacion,
                                    callback: function($$v) {
                                      _vm.tipo_asignacion = $$v
                                    },
                                    expression: "tipo_asignacion"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Continuo", value: "1" }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "Discontinuo", value: "2" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  label: "Fecha de inicio",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha de finalización",
                                  type: "date",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              class:
                                _vm.tipo_asignacion === "1" ? "md12" : "md6"
                            },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.horarios,
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  "item-text": function(val) {
                                    return (
                                      val.descripcion +
                                      ": " +
                                      _vm
                                        .$moment(val.hora_inicio, "HH:mm:ss")
                                        .format("HH:mm") +
                                      " - " +
                                      _vm
                                        .$moment(val.hora_fin, "HH:mm:ss")
                                        .format("HH:mm")
                                    )
                                  },
                                  label:
                                    _vm.tipo_asignacion === "1"
                                      ? "Seleccione un horario"
                                      : "Seleccione primer horario",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.id_horario,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_horario", $$v)
                                  },
                                  expression: "form.id_horario"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.tipo_asignacion === "2"
                            ? _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.horarios,
                                      "item-value": function(val) {
                                        return parseInt(val.id)
                                      },
                                      "item-text": function(val) {
                                        return (
                                          val.descripcion +
                                          ": " +
                                          _vm
                                            .$moment(
                                              val.hora_inicio,
                                              "HH:mm:ss"
                                            )
                                            .format("HH:mm") +
                                          " - " +
                                          _vm
                                            .$moment(val.hora_fin, "HH:mm:ss")
                                            .format("HH:mm")
                                        )
                                      },
                                      label: "Seleccione segundo horario",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.id_horario2,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "id_horario2", $$v)
                                      },
                                      expression: "form.id_horario2"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-741a079e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-741a079e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asignacion_horario/dialogs/PersonaHorario.vue
// module id = null
// module chunks = 